import "prismjs/components/prism-json";
import "prismjs/themes/prism.css";
import { h } from "preact";

// import { emit } from '@create-figma-plugin/utilities';
import { Button } from "@modulz/design-system";
import { useState } from "preact/hooks";
import { highlight, languages } from "prismjs/components/prism-core";

import { VerticalSpace } from "../components/vertical-space";
import { Editor } from "../editor";
import { WidgetConfig } from "../graphpad.types";
import { postMessageToFigjam } from "./post-message-to-figjam";

export const HelpPanel = (props: { widgetConfig: WidgetConfig }) => {
  const [text, setText] = useState(JSON.stringify(props.widgetConfig, null, 2));

  const handleSubmitConfig = () => {
    // try to parse newText as JSON
    try {
      const parsed: WidgetConfig = JSON.parse(text);
      // emit("UPDATE_WIDGET_CONFIG", parsed);
      postMessageToFigjam({
        type: "UPDATE_WIDGET_CONFIG",
        data: {
          widgetConfig: parsed,
        },
      });
    } catch (e) {
      console.warn("Invalid JSON");
    }
  };

  return (
    <div>
      <VerticalSpace space="small" />
      <h2>Vega Lite Documentation</h2>
      <ul>
        <li>
          For best results, this widget assumes some experience with the
          Vega-Lite language. Your feedback is welcome to help me improve the
          onboarding experience.
        </li>
        <li>
          The basics are quick to learn, but there is a lifetime of advanced
          techniques to master!
        </li>
        <li>
          You may visit the{" "}
          <a
            href="https://vega.github.io/vega-lite/docs/"
            target="_blank"
            rel="noreferrer"
          >
            Vega-Lite documentation
          </a>
          , the Vega-Lite Dash docset, or the{" "}
          <a
            href="https://vega.github.io/vega-lite/examples/#community-examples"
            target="_blank"
            rel="noreferrer"
          >
            examples page
          </a>
        </li>
      </ul>
      <h2>Quickstart</h2>
      <ul>
        <li>
          Edit the JSON definition in the Define Graph Tab. Click 'Run Graph'
          when you're ready to apply it, or use the cmd + enter keyboard
          shortcut.
        </li>

        <li>
          Click "format" to tidy your JSON (standardize spacing, indentation)
        </li>
        <li>
          The JSON editor works like VSCode. Keyboard shortcuts, ctrl+z (undo),
          etc should work as usual. Press F1 to see the full command palette.
        </li>
        <li>In the first dropdown to select a starter graph template</li>
        <li>Use the second dropdown to choose a theme</li>
        <li>
          You can optionally upload CSV or JSON datasets in the "Choose Data"
          tab.
        </li>
        <li>
          The "Choose Data" tab is not required, it's fine to define your rows
          directly in the graph definition. It is available if you would like to
          work with large datasets. At this time, both JSON and CSV are
          supported.
        </li>
      </ul>
      <h3>Control Panel (advanced)</h3>
      <p>This panel allows for editing the size of your editor.</p>
      <details>
        <summary>Click to expand the hidden control panel</summary>
        <Editor
          onValueInput={setText}
          rows={8}
          value={text}
          onValueChange={setText}
          highlight={(code: string) => highlight(code, languages.json)}
          padding={10}
          style={{
            fontFamily: '"Fira code", "Fira Mono", monospace',
            fontSize: 12,
          }}
        />
        <Button variant="green" onClick={handleSubmitConfig}>
          Save configuration
        </Button>
      </details>

      <VerticalSpace space="small" />
    </div>
  );
};
